/**
     * Featured On Carousel Banner
     */
 if ($('#featuredOnList').length) {
    $('#featuredOnList').slick({
        autoplay: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        mobileFirst: true,
        centerMode: true,
        responsive: [
            {
                breakpoint: 540,
                settings: {
                    slidesToShow: 7
                }
            },
            {
                breakpoint: 850,
                settings: "unslick"
            }
        ]
    });
}
